import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';

const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen section-padding">
      <div className="container">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="display-md text-white mb-6">Privacy Policy</h1>
          </div>
          <Card className="feature-card">
            <CardHeader>
              <CardTitle className="h2 text-white">
                Effective Date: 01/07/2025</CardTitle>
              <CardDescription className="body-md">
                CxSquare Solutions (“CxSquare”, “we”, “our”, “us”). Your privacy is important to us.This Privacy Policy explains how we collect, use, disclose, and protect your information when you visit our website and use our services, including our SaaS products for CRM, eCommerce, Applicant Tracking System (ATS), and other business applications.
              </CardDescription>
            </CardHeader>
            <CardContent className="prose prose-invert max-w-none text-slate-300 space-y-6">
              <h4>1. Information We Collect</h4>
              <span className="body-sm text-slate-400">We collect both personal and non-personal information when you interact with our website and services.</span>
              <h4>1.1 Personal Information</h4>
              <span>
                <span className="body-sm text-slate-400">Includes, but is not limited to:</span>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Full name</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Email address</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Phone number</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Company name and role</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Billing and payment information</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Login credentials</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">IP address and geolocation</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Any other information you provide when you contact us or sign up</span>
                </div>
              </span>
              <h4>1.2 Non-Personal Information</h4>
              <span>
                <span className="body-sm text-slate-400">Includes technical and usage data such as:</span>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Browser type and version</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Device type and OS</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Referral URLs</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Usage logs and interaction with our web pages or features</span>
                </div>
              </span>
              <h4>2. How We Use Your Information</h4>
              <span>
                <span className="body-sm text-slate-400">We use your information to:</span>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Provide, maintain, and improve our services</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Respond to inquiries or support requests</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Send you service-related notices and updates</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Personalize your experience</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Conduct analytics to improve user experience</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Process billing and transactions</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Comply with legal obligations</span>
                </div>
              </span>
              <h4>3. How We Share Your Information</h4>
              <span>
                <span className="body-sm text-slate-400">We do not sell your personal information. We may share it with:</span>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Third-party service providers (e.g., payment gateways, hosting providers, analytics services)</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Regulatory or legal authorities when required by law</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Successors in case of merger, acquisition, or asset transfer</span>
                </div>
                <span className="body-sm text-slate-400">All third parties are contractually obligated to protect your data and use it only as necessary to provide their services.</span>
              </span>
              <h4>4. Data Security</h4>
              <span>
                <span className="body-sm text-slate-400">
                  We use appropriate administrative, technical, and physical safeguards to protect your information. This includes
                  encryption, secure access controls, regular security audits, and compliance with industry standards like ISO 27001
                  or SOC 2 (if applicable).
                </span>
              </span>
              <h4>5. Data Retention</h4>
              <span>
                <span className="body-sm text-slate-400">We retain your information for as long as necessary to:</span>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Fulfill the purposes outlined in this policy</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Meet legal and regulatory obligations</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Enforce our agreements and protect our rights</span>
                </div>
                <span className="body-sm text-slate-400">You may request data deletion at any time, subject to legal and contractual limitations.</span>
              </span>
              <h4>6. Your Rights and Choices</h4>
              <span>
                <span className="body-sm text-slate-400">Depending on your jurisdiction, you may have the right to:</span>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Access the personal information we hold about you</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Correct inaccurate information</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Request deletion of your data</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Object to or restrict processing</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Withdraw consent (where applicable)</span>
                </div>
                <span className="body-sm text-slate-400">To exercise these rights, please contact us at  <a href="mailto:privacy@cxsquare.solutions" className="text-green-400">
                  privacy@cxsquare.solutions
                </a>.</span>
              </span>
              <h4>7. Cookies and Tracking Technologies</h4>
              <span>
                <span className="body-sm text-slate-400">We use cookies and similar technologies to:</span>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Improve website functionality and user experience</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Analyze traffic and performance</span>
                </div>
                <div className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="body-sm text-slate-400">Provide targeted marketing and retargeting (if applicable)</span>
                </div>
                <span className="body-sm text-slate-400">You may manage your cookie preferences via your browser settings.</span>
              </span>
              <h4>8. Third-Party Links</h4>
              <span>
                <span className="body-sm text-slate-400">Our website may contain links to third-party websites or services. We are not responsible for their privacy
                  practices. We encourage you to review their policies before providing any information.
                </span>
              </span>
              <h4>9. International Data Transfers</h4>
              <span>
                <span className="body-sm text-slate-400">If you are accessing our services from outside the country where our servers are located, your data may be
                  transferred across borders and processed in jurisdictions with different data protection laws. We ensure such
                  transfers are compliant with applicable legal frameworks (e.g., Standard Contractual Clauses for the EU).
                </span>
              </span>
              <h4>10. Changes to This Privacy Policy</h4>
              <span>
                <span className="body-sm text-slate-400">We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated
                  effective date. If significant changes are made, we will notify you via email or a prominent notice on our website.
                </span>
              </span>
              <h4>11. Contact Us</h4>
              <span>
                <span className="body-sm text-slate-400">
                  If you have any questions or concerns about this Privacy Policy or your personal data, please contact us at:
                </span>
                <span>
                  <p className="text-400 font-medium">CxSquare Solutions</p>
                </span>
                <span>
                  <p><a href="mailto:privacy@cxsquare.solutions" className="text-green-400">
                    privacy@cxsquare.solutions
                  </a></p>
                </span>
                <span>
                  <p><a href="https://www.cxsquare.solutions" target="_blank" rel="noopener noreferrer" className="text-green-400">
                    https://www.cxsquare.solutions
                  </a></p>
                </span>
              </span>

            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
